import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "resultados tw-w-full tw-flex tw-justify-center tw-h-full tw-items-center tw-p-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tw-bg-gray-50 tw-rounded tw-py-4 tw-shadow-lg" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Resultados"),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-sm" }, "Es IMPORTANTE que la interpretación de estos Resultados la realices junto a tu médico.")
], -1)
const _hoisted_3 = { class: "tw-w-full tw-flex tw-items-center tw-justify-center" }
const _hoisted_4 = {
  key: 0,
  ref: "contenedorResultados",
  style: {"max-height":"calc(100vh - 34vh)"},
  class: "tw-w-full tw-grid xl:tw-grid-cols-2 tw-gap-2 tw-mx-auto tw-mt-2 tw-bg-gray-100 tw-overflow-auto tw-p-2 tw-rounded"
}
const _hoisted_5 = {
  key: 1,
  style: {"max-height":"calc(100vh - 35vh)"},
  class: "tw-w-full tw-mt-2 tw-bg-gray-50 tw-overflow-auto tw-p-2 tw-space-y-2 tw-rounded"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "No se encontraron resultados.", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "tw-w-full tw-h-full"
}
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_resultados_card = _resolveComponent("resultados-card")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast, { position: "bottom-right" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Card, {
        style: {"background":"none","box-shadow":"none"},
        class: "animate tw-w-full tw-h-full! p-shadow-5"
      }, {
        title: _withCtx(() => [
          _hoisted_2
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_SelectButton, {
              onChange: _ctx.handleTipoChange,
              size: "small",
              options: _ctx.tipos,
              modelValue: _ctx.tipoSeleccionado,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tipoSeleccionado) = $event)),
              "aria-labelledby": "basic"
            }, null, 8, ["onChange", "options", "modelValue"])
          ]),
          (_ctx.evolucionesList?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.evolucionesList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_resultados_card, {
                    key: item,
                    onCompartir: ($event: any) => (_ctx.handleCompartirClick(index)),
                    onVer: ($event: any) => (_ctx.handleVerClick(index)),
                    onVisualizar: ($event: any) => (_ctx.handleVisualizar(index)),
                    datos: item
                  }, null, 8, ["onCompartir", "onVer", "onVisualizar", "datos"]))
                }), 128))
              ], 512))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.resultadoFormActive,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.resultadoFormActive) = $event)),
      class: "popup-visorEstudios",
      style: {'width':'100%','height':'100%'}
    }, {
      header: _withCtx(() => [
        _hoisted_8
      ]),
      default: _withCtx(() => [
        (_ctx.resultadoFormActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("iframe", {
                src: _ctx.evolucionSeleccionada?.pac?.estudio?.visor,
                frameborder: "0",
                width: "100%",
                height: "100%"
              }, null, 8, _hoisted_10)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}